/**
 * Inflatable electric pump upsell — client fallback when Liquid cannot resolve
 * a newly published product via theme product picker or all_products.
 */
(function () {
  var PUMP_HANDLE = "isup-electric-air-pump-12v-1-4-bar-20-psi";
  var strings = window.exocetPumpStrings || {};
  var pending = false;
  var DISCOUNT_PCT = 15;

  var INFLATABLE_BOARD_HANDLES = [
    "energy-hp-allround-isup-20-psi",
    "energy-sl-allround-isup-15-psi",
    "neon-hp-inflatable-windsurf-20-psi",
    "neon-sl-inflatable-windsurf-15-psi",
    "sonic-hp-touring-isup-20-psi",
    "sonic-sl-touring-isup-15-psi",
    "zypher-hp-iwindsup-20-psi",
    "zypher-sl-iwindsup-15-psi",
  ];

  function isInflatableBoardPage() {
    var path = window.location.pathname;
    return INFLATABLE_BOARD_HANDLES.some(function (handle) {
      return path.indexOf("/products/" + handle) !== -1;
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return "€" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function ensureInflatablePumpUpsell() {
    if (!isInflatableBoardPage()) return;

    var section = document.querySelector(".product-hero-2026");
    if (!section) return;
    if (section.querySelector('[data-accessory-upsell="recommended_pump_product"]')) return;

    var buyButtons = section.querySelector("[data-buy-buttons]");
    var anchor = section.querySelector(".rec-accessory-block") || buyButtons;
    if (!anchor || !anchor.parentNode) return;

    if (pending) return;
    pending = true;
    fetch((window.Shopify?.routes?.root || "/") + "products/" + PUMP_HANDLE + ".js")
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        if (section.querySelector('[data-accessory-upsell="recommended_pump_product"]')) return;

        var variant = product.variants.find(function (item) { return item.available; });
        if (!variant || !section.isConnected || !strings.label) return;
        var price = variant.price;
        var discounted = Math.round((price * (100 - DISCOUNT_PCT)) / 100);
        var productUrl = new URL(product.url, window.location.origin);
        if (productUrl.origin !== window.location.origin || !/^https?:$/.test(productUrl.protocol)) return;

        function node(tag, className, text, parent) {
          var element = document.createElement(tag);
          element.className = className;
          if (text != null) element.textContent = text;
          if (parent) parent.appendChild(element);
          return element;
        }

        var block = node("div", "rec-bag-block rec-accessory-block");
        block.setAttribute("data-accessory-upsell", "recommended_pump_product");
        block.setAttribute("data-pump-fallback", "");
        var label = node("span", "rec-bag-block__label", strings.label, block);
        node("span", "rec-bag-block__label-badge", "-" + DISCOUNT_PCT + "%", label);
        var body = node("div", "rec-bag-block__body", null, block);
        var productNode = node("div", "rec-bag-block__product", null, body);
        if (product.featured_image) {
          var imageUrl = new URL(product.featured_image, window.location.origin);
          if (/^https?:$/.test(imageUrl.protocol)) {
            var imageLink = node("a", "rec-bag-block__image", null, productNode);
            imageLink.href = productUrl.href;
            imageLink.setAttribute("aria-label", product.title);
            var image = node("img", "rec-bag-block__img", null, imageLink);
            imageUrl.searchParams.set("width", "480");
            image.src = imageUrl.href;
            image.srcset = [68, 136, 204, 408].map(function (width) {
              imageUrl.searchParams.set("width", String(width));
              return imageUrl.href + " " + width + "w";
            }).join(", ");
            image.sizes = "68px";
            image.alt = product.title;
            image.width = 68;
            image.height = 68;
            image.loading = "lazy";
            image.decoding = "async";
          }
        }
        var info = node("div", "rec-bag-block__info", null, productNode);
        var link = node("a", "rec-bag-block__name", product.title, info);
        link.href = productUrl.href;
        var prices = node("div", "rec-bag-block__price-row", null, info);
        node("span", "rec-bag-block__price--discounted", formatMoney(discounted), prices);
        node("span", "rec-bag-block__price--original", formatMoney(price), prices);
        var button = node("button", "rec-bag-block__atc", null, body);
        button.type = "button";
        button.setAttribute("data-rec-accessory-add", "");
        button.setAttribute("data-rec-accessory-id", variant.id);
        button.setAttribute("data-rec-accessory-error", strings.error);
        button.setAttribute("aria-label", strings.add);
        var buttonText = node("span", "rec-bag-block__atc-text", null, button);
        node("span", "rec-bag-block__atc-label rec-bag-block__atc-label--desktop", strings.save, buttonText);
        node("span", "rec-bag-block__atc-label rec-bag-block__atc-label--mobile", strings.add, buttonText);
        node("span", "rec-bag-block__atc-label rec-bag-block__atc-label--mobile-compact", strings.addShort, buttonText);
        node("span", "rec-bag-block__atc-price", formatMoney(discounted), buttonText);

        if (anchor.classList.contains("rec-accessory-block")) {
          anchor.parentNode.insertBefore(block, anchor);
        } else {
          anchor.parentNode.insertBefore(block, anchor.nextSibling);
        }
      })
      .catch(function () {})
      .finally(function () { pending = false; });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureInflatablePumpUpsell);
  } else {
    ensureInflatablePumpUpsell();
  }

  document.addEventListener("product:variant-change", function () {
    setTimeout(ensureInflatablePumpUpsell, 150);
  });
})();
